import {Deserializable} from '../deserializable';


export  class SoVanThu implements Deserializable
{
  public  id: number;
  public  tenSoVanThu: string;
  public  soVaoSo: number;
  public  kyHieuVanBan: string;
  public  soVaoSoDi: number;
  public  kyHieuVanBanDi: string;
  public  kieuChiaVBdi: number;
  public  logUpdate: string;
  public  suDung: number = 0;
  public  stt: number;
  public  linhVucVBDen: number;
  public  loaiVBDen: number;
  public  linhVucVBDi: number;
  public  loaiVBdi: number;
  public  doKhan: number;
  public  doMat: number;
  public  nhomVBdiID: number;
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
